import React from 'react';
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';
import GeneralAlert from '../helpers/GeneralAlert';
import { UIProperties } from '../UIProperties';

import './FeedbackUI.css'

const FeedbackUI = (props: UIProperties<FeedbackUIConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container modal-disable-select">
			<div>
				<GeneralAlert id="directions-ui-alert" dispatch={props.dispatch} parameters={{
					title: 'Charge Nurse Mentoring',
					img: constants.icons.nurseManager,
					text: props.parameters.text,
					srcMain: './assets/images/general/components/general_alert/button_tryagain.png',
					srcDown: './assets/images/general/components/general_alert/button_tryagain_down.png',
					srcDisabled: './assets/images/general/components/general_alert/button_tryagain.png',
					unseenText: 'Try Again',
					smallerTitle: true,
					useBigText: false,
					onContinueClicked: props.parameters.onContinueClicked
				}}></GeneralAlert>
			</div>
		</div>
	);

};

export interface FeedbackUIConfig extends BaseConfig {
	text: string;
	onContinueClicked: () => void;
}

export default FeedbackUI;